import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { SEO } from "../components/site/SEO";
import { PageHeader } from "../components/site/primitives";
import { Reveal } from "../components/site/primitives";
import { API, imgUrl, money, useCart } from "../cart";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("All");
  const [q, setQ] = useState("");
  const [sort, setSort] = useState("");
  const { add } = useCart();

  useEffect(() => { axios.get(`${API}/products/categories`).then((r) => setCats(r.data)); }, []);
  useEffect(() => {
    const params = {};
    if (active !== "All") params.category = active;
    if (q) params.q = q;
    if (sort) params.sort = sort;
    axios.get(`${API}/products`, { params }).then((r) => setProducts(r.data));
  }, [active, q, sort]);

  return (
    <>
      <SEO title="Shop Luxury Home Decor & Gifts | Emporium London"
        description="Shop Emporium London — luxury home decor, tableware, candles, gifting and games including the Luxury Metallic Chess Set. UK delivery, secure checkout."
        path="/shop" />
      <main>
        <PageHeader overline="Shop" title="Shop luxury home decor & gifts"
          intro="Premium decor, gifting and lifestyle pieces for homes, restaurants, hotels and corporate clients — customisable to your theme." />

        <section className="relative z-10 px-6 md:px-12 lg:px-16 py-16 md:py-20">
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 justify-between mb-10">
            <div className="flex flex-wrap gap-2">
              {["All", ...cats].map((c) => (
                <button key={c} data-testid={`shop-cat-${c}`} onClick={() => setActive(c)}
                  className={`border px-4 py-2 font-mono text-[10px] tracking-[0.15em] uppercase transition-colors ${active === c ? "bg-[var(--text-primary)] text-[var(--bg-primary)] border-[var(--text-primary)]" : "border-black/20 text-[var(--text-secondary)] hover:border-black/50"}`}>{c}</button>
              ))}
            </div>
            <div className="flex gap-3">
              <input data-testid="shop-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search products"
                className="bg-transparent border-b border-black/20 py-2 px-1 text-sm focus:border-[var(--text-primary)] outline-none" />
              <select data-testid="shop-sort" value={sort} onChange={(e) => setSort(e.target.value)}
                className="bg-transparent border-b border-black/20 py-2 text-sm font-mono tracking-[0.1em] uppercase text-[var(--text-secondary)] outline-none">
                <option value="">Sort</option>
                <option value="price_asc">Price ↑</option>
                <option value="price_desc">Price ↓</option>
                <option value="name">Name</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
            {products.map((p, i) => (
              <Reveal key={p.id} delay={(i % 4) * 0.05}>
                <div data-testid={`shop-product-${p.id}`} className="group flex flex-col">
                  <Link to={`/product/${p.id}`} className="block overflow-hidden bg-[var(--bg-tertiary)]">
                    <img src={imgUrl(p.image)} alt={p.name} className="w-full aspect-square object-cover transition-transform duration-700 group-hover:scale-105" />
                  </Link>
                  <div className="mt-4 flex-1 flex flex-col">
                    <Link to={`/product/${p.id}`}><h2 className="font-serif text-xl text-[var(--text-primary)] leading-snug hover:text-[var(--brass)] transition-colors">{p.name}</h2></Link>
                    <div className="mt-1 flex items-center justify-between">
                      <span className="font-mono text-[10px] tracking-[0.15em] uppercase text-[var(--text-muted)]">{p.category}</span>
                      <span className="font-serif text-lg text-[var(--text-primary)]">{money(p.price)}</span>
                    </div>
                    <p className={`mt-1 font-mono text-[10px] tracking-[0.12em] uppercase ${p.stock > 0 ? "text-[var(--brass)]" : "text-[var(--text-muted)]"}`}>{p.stock > 0 ? "In stock" : "Pre-order"}</p>
                    <button data-testid={`shop-add-${p.id}`} disabled={p.stock <= 0}
                      onClick={() => { add(p); toast.success(`${p.name} added to basket`); }}
                      className="mt-3 border border-black/20 h-11 font-mono text-[10px] tracking-[0.18em] uppercase hover:bg-[var(--text-primary)] hover:text-[var(--bg-primary)] transition-colors disabled:opacity-40">
                      {p.stock > 0 ? "Add to Basket" : "Enquire"}
                    </button>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </section>
      </main>
    </>
  );
}
